import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { notifyError } from "../helper/Toaster";
import React from "react";

const PrivacyPolicyModal = (props) => {
  const [privacyPolicy, setPrivacyPolicy] = React.useState(false);
  const [termsConditions, setTermsConditions] = React.useState(false);

  const beforeClose = () => {
    if (!privacyPolicy || !termsConditions) {
      if(!privacyPolicy) {
        notifyError("Please agree to the privacy policy");
      } else if (!termsConditions) {
        notifyError("Please agree to the terms and conditions");
      }
      return false;
    }
    props.onSubmit();
  }

  return (
    <Modal
      {...props}
      // size="md"
      dialogClassName="modal-38"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {/* <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Modal heading
        </Modal.Title>
      </Modal.Header> */}
      <Modal.Body>
        <div className="privacy-doc-img">
          <img
            src={`${process.env.PUBLIC_URL}/img/privacy-policy.png`}
            alt="Privacy Policy Image"
          />
        </div>
        <div className="privacy-policy-terms d-flex justify-content-center gap-2 w-100 my-3">
          <span>
            <input onClick={() => setPrivacyPolicy(!privacyPolicy)} className="me-1" type="checkbox" name="privacy-policy" />
            Agree to our <a href="#">Privacy Policy</a>
          </span>
          <span>
            <input onClick={() => setTermsConditions(!termsConditions)} className="me-1" type="checkbox" name="terms-conditions" />
            Agree to our <a href="#">Terms & Conditions</a>
          </span>
        </div>
        <div className="d-flex justify-content-center gap-2 w-100 mt-3">
          <Button
            className="border-0 text-grey-1 fw-400"
            variant="light"
            onClick={props.onHide}
          >
            Back
          </Button>
          <Button className="model-continue-btn" onClick={beforeClose}>
            Continue
          </Button>
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default PrivacyPolicyModal;
